import FittedStackedBarChart from './FittedStackedBarChart'

export default FittedStackedBarChart
